// أول حرف من الاسم الأول + أول حرف من اسم العائلة، بحروف كبيرة (لاتينية للأسماء اللاتينية).
export const initials = (name = "") => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  const first = parts[0][0] || "";
  const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
  return (first + last).toUpperCase();
};
